<template>
  <div class="auth-login" :class="{ 'auth-login--admin': isAdmin, 'auth-login--register-progress': registerProgress }">
    <a href="#auth-login-main" class="auth-login__skip-link">
      {{ skipLinkLabel }}
    </a>

    <div
      aria-live="polite"
      aria-atomic="true"
      class="auth-login__sr-only"
    >
      {{ injectedAnnouncement }}
    </div>

    <aside class="auth-login__sidebar" :aria-label="sidebarAriaLabel">
      <div class="auth-login__sidebar-inner">
        <div class="auth-login__brand-row">
          <AuthBrandLogo />
<!--          <AuthThemeToggle />-->
        </div>

        <div class="auth-login__secure-badge">
          <AuthIcon name="lock" />
          {{ secureBadgeText }}
        </div>

        <h1 class="auth-login__sidebar-heading">{{ sidebarTitle }}</h1>
        <p v-if="sidebarText" class="auth-login__sidebar-text">{{ sidebarText }}</p>

        <div v-if="$slots['sidebar-progress']" class="auth-login__sidebar-progress">
          <slot name="sidebar-progress" />
        </div>
      </div>

      <!--
        <footer v-if="!isAdmin" class="auth-login__sidebar-footer">
          Need help? Call
          <button type="button" class="auth-login__help-action" @click="openHelp">
            {{ supportPhone }}
          </button>
        </footer>
      -->
    </aside>

    <main id="auth-login-main" class="auth-login__main" :aria-label="mainAriaLabel">
      <div class="auth-login__main-inner">
        <slot />
      </div>

      <footer class="auth-login__page-footer">
        <!--
          <div v-if="!isAdmin" class="auth-login__support-pill">
            <AuthIcon name="phone" />
            <span>Need help?</span>
            <button type="button" class="auth-login__help-action" @click="openHelp">
              Call {{ supportPhone }}
            </button>
          </div>
        -->

        <AuthLegalLinks
          v-if="!isAdmin"
          :terms-link="termsLink"
          :privacy-link="privacyLink"
          :consent-link="consentLink"
        />

        <p class="auth-login__copyright">©{{ year }}. RemoniHealth. All Rights Reserved.</p>
      </footer>
    </main>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import AuthIcon from './AuthIcon.vue'
import AuthBrandLogo from './AuthBrandLogo.vue'
// import AuthThemeToggle from './AuthThemeToggle.vue'
import AuthLegalLinks from './AuthLegalLinks.vue'
// import { toRef } from 'vue'
// import { useAuthHelp } from '../composables/useAuthHelp.js'

const props = defineProps({
  sidebarTitle: { type: String, required: true },
  sidebarText:  { type: String, default: '' },
  supportPhone: { type: String, default: '815-908-2020' },
  isAdmin:      { type: Boolean, default: false },
  mode:         { type: String, default: 'login' },
  termsLink:    { type: String, default: '' },
  privacyLink:  { type: String, default: '' },
  consentLink:  { type: String, default: '' },
  registerProgress: { type: Boolean, default: false },
})

const injectedAnnouncement = inject('authLoginAnnouncement', ref(''))
// const { openHelp } = useAuthHelp(toRef(props, 'supportPhone'))

const year = new Date().getFullYear()
const isRegister = computed(() => props.mode === 'register')
const skipLinkLabel = computed(() => isRegister.value ? 'Skip to registration form' : 'Skip to sign in form')
const sidebarAriaLabel = computed(() => isRegister.value ? 'Registration information' : 'Sign in information')
const mainAriaLabel = computed(() => isRegister.value ? 'Registration form' : 'Sign in form')
const secureBadgeText = computed(() => isRegister.value ? 'Secure, encrypted registration' : 'Secure, encrypted sign-in')
</script>
